import api from './api';
import i18n from '@/plugins/i18n';

function handleApiError(commit, err) {
	let message;

	if (err.response?.status === 423) {
		const { i18nKey, i18nParams } = err.response.data;
		if (i18nKey) {
			message = i18n.t(i18nKey, i18nParams);
		} else {
			message = i18n.t('error_locked'); // fallback
		}
	} else {
		message = err.response?.data.message;
	}

	commit('showError', { message });
}

const state = {
	success: false,
	error: false,
	loadingError: false,
	roles: [],
	qualifications: [],
	message: '',
	locales: {},
};
const getters = {};
const mutations = {
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	showError(state, { message }) {
		state.error = true;
		state.message = message;
	},
	showloadingError(state, { message }) {
		state.loadingError = true;
		state.message = message;
	},
	hideError(state) {
		state.error = false;
		state.loadingError = false;
		state.message = '';
	},
	setRoles(state, { roles }) {
		state.roles = roles.map((role) => ({ ...role, title: role.name }));
	},
	setQualifications(state, { qualifications }) {
		state.qualifications = qualifications.map((q) => ({ ...q, title: q.name }));
	},
	setLocales(state, { locales }) {
		state.locales = locales;
	},
};
const actions = {
	async deleteUser({ state, commit, rootGetters, dispatch }, user) {
		var result;
		if (!user.deleted) {
			result = api.deleteUser(user);
		} else {
			result = api.editUser({ id: user.id, deleted: false });
		}
		return result
			.then(() => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
				dispatch('users/load', null, { root: true });
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
			});
	},
	async updateUser({ state, commit, rootGetters, dispatch }, user) {
		var result;
		try {
			if (user.id) {
				result = await api.editUser(user);
			} else {
				result = await api.addUser(user);
			}

			commit('showSuccess');
			window.setTimeout(() => {
				commit('hideSuccess');
			}, 1500);
			await dispatch('users/load', null, { root: true });
		} catch (err) {
			let message = err.response.data.message;
			if (err.response.status === 423) {
				message = i18n.t('error_locked');
			}
			commit('showError', { message });
			window.setTimeout(() => {
				commit('hideError');
			}, 3000);
		}
	},
	async loadUser({ commit }, id) {
		return api
			.load(id)
			.then((response) => {
				const user = response.data;
				return user;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showLoadingError', { message });
			});
	},
	async getRoles({ commit }) {
		return api
			.getRoles()
			.then((response) => {
				const roles = response.data;
				commit('setRoles', { roles });
				return roles;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showLoadingError', { message });
			});
	},
	async getQualifications({ commit }) {
		try {
			const response = await api.getQualifications();
			const qualifications = response.data;
			commit('setQualifications', { qualifications });
			return qualifications;
		} catch (err) {
			const message = err.response.data.message;
			commit('showLoadingError', { message });
		}
	},
	async setPassword({ commit }, data) {
		const response = await api.setPassword(data.user, data.password);
		if (response.status < 200 || response.status > 299) {
			commit('showError', { message: response.data.message });
			window.setTimeout(() => {
				commit('hideError');
			}, 3000);
		} else {
			commit('showSuccess');
			window.setTimeout(() => {
				commit('hideSuccess');
			}, 1500);
		}
		return response;
	},
	async createAbsence({ commit, dispatch }, absence) {
		commit('hideError');

		return api
			.createAbsence(absence)
			.then(async () => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				handleApiError(commit, err);
				window.setTimeout(() => {
					commit('hideError');
				}, 5000);
				throw err;
			});
	},
	async updateAbsence({ commit, dispatch }, absence) {
		commit('hideError');
		try {
			const response = await api.updateAbsence(absence);
			commit('showSuccess');
			window.setTimeout(() => {
				commit('hideSuccess');
			}, 1500);
			return response;
		} catch (err) {
			handleApiError(commit, err);
			window.setTimeout(() => {
				commit('hideError');
			}, 3000);
			throw err;
		}
	},
	async deleteAbsence({ commit, dispatch }, absence) {
		commit('hideError');

		return api
			.deleteAbsence(absence.id, absence.changeComment)
			.then(async () => {
				commit('showSuccess');
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				commit('users/removeDeletedAbsence', absence.id, { root: true });
				let message = err.response.data.message;
				if (err.response.status === 423) {
					message = i18n.t('error_locked');
				}
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				throw err;
			});
	},
	async getUsersById({ commit }) {
		try {
			const result = await api.getUsersById();
			return result.data;
		} catch (err) {
			const message = err.response.data.message;
			commit('showError', { message });
		}
	},
};
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
